import { FormProvider, useForm } from 'react-hook-form'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Dialog from '../../atoms/feedback/Dialog'
import MessageForm, { FormParams } from '../chat/MessageForm'
import { useClientMoneyspaceBulkChatDialog } from '../../../hooks/useDialog'
import useDay from '../../../hooks/useDay'
import { ChatActions } from '../../../store/chat'
import { ReservedMessageRepeatType } from '../../../types/Chat'
import useScheduleExpression from '../../../hooks/useScheduleExpression'

export default function ClientMoneyspaceBulkChatDialog() {
  const { state, close } = useClientMoneyspaceBulkChatDialog()
  const { formatDate } = useDay()
  const dispatch = useDispatch()
  const { generate } = useScheduleExpression()
  const { formatTime } = useDay()

  const form = useForm<FormParams>({
    defaultValues: {
      type: 1,
      date: formatDate(new Date()),
      time: new Date(),
      repeatType: '1',
      repeatDayOfWeek: 1,
      repeatDayOfMonth: 1,
      repeatTime: new Date(),
      repeatBaseDate: formatDate(new Date()),
      message: '',
    },
  })

  const handleSend = useCallback(
    (params: FormParams) => {
      const moneyspaceIds = state?.moneyspaceIds ?? []
      if (Number(params.type) === 1) {
        dispatch(
          ChatActions.postMessages({
            moneyspaceIds,
            description: params.message,
          })
        )
      } else {
        const schedule = generate({
          type: Number(params.type) === 2 ? 'schedule' : 'repeat',
          date: params.date ?? '',
          time: params.time ? formatTime(params.time) : '',
          repeatType: (Number(params.repeatType) ?? 1) as ReservedMessageRepeatType,
          repeatTime: params.repeatTime ? formatTime(params.repeatTime) : '',
          repeatDayOfWeek: Number(params.repeatDayOfWeek ?? 1),
          repeatDayOfMonth: Number(params.repeatDayOfMonth ?? 1),
          repeatBaseDate: params.repeatBaseDate ?? '',
        })
        dispatch(
          ChatActions.postReservedMessage({
            moneyspaceIds,
            description: params.message,
            scheduleExpression: schedule,
          })
        )
      }
    },
    [dispatch, state, generate, formatTime]
  )

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="メッセージ一括送信"
      onSubmit={form.handleSubmit(handleSend)}
    >
      <FormProvider {...form}>
        <MessageForm moneyspaceIds={state?.moneyspaceIds ?? []} />
      </FormProvider>
    </Dialog>
  )
}
